/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_OceaniaInputs */

const bn_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওশেনিয়া`)
};

const de_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ozeanien`)
};

const el_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ωκεανία`)
};

const en_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const es_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanía`)
};

const fr_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Océanie`)
};

const hi_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओशिनिया`)
};

const hu_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Óceánia`)
};

const id_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const it_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const ja_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オセアニア`)
};

const ko_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오세아니아`)
};

const nl_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanië`)
};

const pl_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceania`)
};

const pt_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceânia`)
};

const ru_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океания`)
};

const sv_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oceanien`)
};

const tr_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okyanusya`)
};

const uk_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Океанія`)
};

const vi_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Châu Đại Dương`)
};

const zh_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大洋洲`)
};

const zh_hant_region_oceania = /** @type {(inputs: Region_OceaniaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大洋洲`)
};

/**
* | output |
* | --- |
* | "Oceania" |
*
* @param {Region_OceaniaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_oceania = /** @type {((inputs?: Region_OceaniaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_OceaniaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_oceania(inputs)
	if (locale === "de") return de_region_oceania(inputs)
	if (locale === "el") return el_region_oceania(inputs)
	if (locale === "en") return en_region_oceania(inputs)
	if (locale === "es") return es_region_oceania(inputs)
	if (locale === "fr") return fr_region_oceania(inputs)
	if (locale === "hi") return hi_region_oceania(inputs)
	if (locale === "hu") return hu_region_oceania(inputs)
	if (locale === "id") return id_region_oceania(inputs)
	if (locale === "it") return it_region_oceania(inputs)
	if (locale === "ja") return ja_region_oceania(inputs)
	if (locale === "ko") return ko_region_oceania(inputs)
	if (locale === "nl") return nl_region_oceania(inputs)
	if (locale === "pl") return pl_region_oceania(inputs)
	if (locale === "pt") return pt_region_oceania(inputs)
	if (locale === "ru") return ru_region_oceania(inputs)
	if (locale === "sv") return sv_region_oceania(inputs)
	if (locale === "tr") return tr_region_oceania(inputs)
	if (locale === "uk") return uk_region_oceania(inputs)
	if (locale === "vi") return vi_region_oceania(inputs)
	if (locale === "zh") return zh_region_oceania(inputs)
	return zh_hant_region_oceania(inputs)
});